import React from 'react';
import ExpediteForm from './components/ExpediteForm';
import ExpediteSignatureResult from './components/ExpediteSignatureResult';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Header />
      <div className='flex flex-col w-full lg:w-1/2 lg:mx-auto pt-6'>
        <div className='flex flex-col gap-y-6'>
          <ExpediteForm />
          <ExpediteSignatureResult />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
